import { createContext } from "react";

const PaymentProfileContext = createContext({
  status: "unknown",
  profile: null,
  ensurePaymentProfile: async () => ({ status: "unknown" }),
  handleAuthorizationChallenge: async () => ({ status: "unknown" }),
  refreshProfile: async () => null,
  saveBillingDetails: async () => ({ status: "unknown" }),
});

export default PaymentProfileContext;
